// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    theme:{
      defaultTheme: 'myCustomTheme',
      themes: {
        myCustomTheme: {
          dark: false,
          colors: {
            primary: '#0044B5',
            secondary: '#FD372C',
            darkblue: '#21296B',
            blue: '#5082F0',
            warning: '#FFBA00',
            yellow: '#FAD42F',
            orange: '#F47925',
            error: '#D12626',
          }
        }
      }
    }
  }
)
